import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type GameCalendarList = paths['/calendar/'];

const getGameCalendarList = createRequest<GameCalendarList>('/pc/calendar/');

export default getGameCalendarList;
